<template>
    <div style="position: relative">


        <!-- 年齢 -->
        <div class="age-box">
            <div class="age-start age">{{ ageStart }}<span class="sai">歳</span></div>
            <div class="age-end age">90<span class="sai">歳</span></div>
        </div>

        <!-- グラフ -->
        <figure class="highcharts-figure" style="margin-bottom: 0">
            <div id="container">
                <highcharts :options="chartOptions" ref="chart"></highcharts>
            </div>
        </figure>


        <!-- 凡例 -->
        <div class="legend-top">
            <img src="@/assets/img/result/legend.png">
        </div>


    </div>

</template>




<script>

import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);

import CalcUtil from "@/store/calcUtil.js"


export default {
    name: "GraphShinchiku.vue",
    components: {
        highcharts: Chart
    },
    props: [
        'calc',
        'mochiie',
        'mochiieNuri',
        'shuunyuu',
        'shishutsu',
        // 'chintai',
        'lifeEventList',
    ],
    data() {
        return {
            showMochiieLoanTextInside: true,
        }
    },
    computed: {
        yMax() {
            let max = Math.max(this.calc.shishutsuMax, this.calc.shuunyuuMaxWithoutTaishokukin);
            if (max === 0) {
                return null;
            }
            max += 100; //最大値に100万円を加算
            max = Math.ceil(max/100) * 100; //百万円単位で切り上げ

            return max;
        },
        ageStart () {
            return this.$store.state.setainushi.age * 1 //storeを読む
        },
        mochiieRatio(){
            return this.agePosition(this.calc.kansaiNenrei());
        },
        mochiieWidth(){
            return (this.mochiieRatio * 100) +"%";
        },
        totalLoanPayment() {
            return CalcUtil.manYenToOkuYen(this.calc.mochiieTotalLoanPayment);
        },
        mochiieLoanText() {
            if (this.rentalAmount === null) {
                return '';
            }
            return '（借入額：'+ this.rentalAmountLocaleString +'万円、'+ this.$store.state.osumai.kikan +'年、金利 '+ this.$store.state.osumai.kinri +'％）';
        },
        rentalAmount() {
            let osumai = this.$store.state.osumai;
            if (!(osumai.kinri>0)) {
                return null;
            }
            if (osumai.loan && osumai.kinri) {
                let kariire = CalcUtil.kariireKanouGaku(osumai.loan*10000, osumai.kinri, osumai.kikan);
                kariire = Math.floor( kariire/ 100000) * 10; //10万円単位
                return kariire;
                // return 3450;
            }
            return null;
        },
        rentalAmountLocaleString() {
            if (this.rentalAmount === null) {
                return null;
            }
            return this.rentalAmount.toLocaleString();
        },
        lifeEventReFormat() {

            //同じ年齢のイベント名を纏めたオブジェクトを作成
            let list = Object.entries(
                this.lifeEventList.reduce((obj, event) => {
                    if (obj[event.age] == null) obj[event.age] = [];
                    obj[event.age].push(event.event);
                    return obj;
                }, {})
            ).map(([age, event, x, y]) => ({age, event, x, y}));

            Object.values(list).forEach(event => {
                event.event = event.event.join('<br>');
                event.x = Number(event.age.replace('歳',''));
                event.y = 0;
            });


            return list;
        },
        retirementPlot() {

            // console.log(this.calc.retirementInfo);
            let plot = [];

            if (this.calc.retirementInfo.setainushi.age && this.calc.retirementInfo.setainushi.kingaku) {
                plot.push([this.calc.retirementInfo.setainushi.age*1, this.yMax-100]);
            }
            if (this.calc.retirementInfo.haiguusha.age && this.calc.retirementInfo.haiguusha.kingaku) {
                let age = this.calc.retirementInfo.haiguusha.age*1;
                // 世帯主と配偶者の年齢差を考慮する
                age += (this.calc.startAge - this.calc.startAgeHaiguusha)*1;
                plot.push([age, this.yMax-100]);
            }

            return plot;
        },
        chartOptions() {

            return {

                chart: {
                    margin: [20, 0, 20, 0] // ここでマージン(上右下左)を設定
                },
                title: {
                    text: ''
                },

                xAxis: {
                    minPadding:0,
                    maxPadding:0,
                    labels: {
                        format: '{text}歳',
                    },
                },

                yAxis: {
                    opposite: true,
                    title: {
                      text: ''
                    },
                    labels: {
                        x: 1,
                        formatter: function() {
                            return this.value+'万円';
                        },
                        style: {
                            'letter-spacing': '-1px',
                            'font-size': '10px',
                        }
                    },
                    plotLines: [{
                        color: '#ccc',
                        width: 5,
                        value: 0
                    }],
                    max: this.yMax,
                },

              legend: {
                  enabled:false,
              },


              series: [
                  {
                      name: '収入',
                      data: this.shuunyuu,
                      type: 'column',
                      color: '#A0B3D7',
                      // pointWidth: 1,
                      // pointInterval: 0,
                      // pointPadding: 0.12,
                      groupPadding: 0,
                      // borderWidth: 0,
                      fillOpacity: 1,
                      zIndex: 5,
                      marker: {
                          enabled: false
                      },
                  },
                  {
                      name: '支出',
                      data: this.shishutsu,
                      lineWidth: 6,
                      // dashStyle: 'shortDot',
                      color: '#233D5B',
                      fillOpacity: 1,
                      zIndex: 6,
                      marker: {
                          enabled: false,
                      },
                  },
                  {
                      name: 'イベント',
                      data: this.lifeEventReFormat,
                      type:'scatter',
                      fillOpacity: 0,
                      zIndex: 10,
                      // type: 'bar',
                      marker: {
                          enabled:true,
                          fillColor: 'white',
                          lineWidth: 2,
                          lineColor: '#00ffff',
                          radius:3,
                          symbol:'url(./img/sumaidot.png)',
                      },
                      tooltip: {
                          headerFormat: '<b>{point.x}歳</b><br>',
                          pointFormat: '{point.event}'
                      }
                  },
                  {
                      name: '退職金省略記号',
                      data: this.retirementPlot,
                      type:'scatter',
                      zIndex: 10,
                      marker: {
                          enabled: true,
                          width: 17,
                          height: 10,
                          symbol:'url(./img/ryaku.png)',
                      },
                      tooltip: {
                          headerFormat: '退職金<br>',
                          pointFormat: ''
                      }
                  }


                ],
                plotOptions: {
                    series: {
                        states: {
                            inactive: {
                                enabled: false
                            }
                        }
                    }
                },

                credits: {
                    enabled: false,
                },

            }
        },
    },
    methods: {
        agePosition(age){
            let start = this.ageStart;
            let end = 90;

            if (age <= this.ageStart) {
                return 0;
            }

            let p = ((age - start) / (end -start));

            return p;
        },
        manYenToOkuYen(manYen) {
            if (manYen < 9999) {
                return manYen;
            }
            let yen = String(manYen);
            let oku = yen.substr(0, yen.length-4);
            return oku+'億'+Number(yen.substr(-4));
        },
    },
    mounted() {
    }
}


</script>


<style lang="scss">
.chart-subtitle {
    color: #333;
    font-weight: bold;
    font-size: 18px;
    //background-color: #fff;
}
//https://stackoverflow.com/questions/31415313/force-highcharts-to-display-tooltip-outside-of-div-container
#container > div {
    overflow:visible !important;
}
svg{
    overflow:visible !important;
}
.highcharts-container {
    overflow:visible !important;
}
#container {
    height: 300px;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}
#container .highcharts-container {
    height: 300px !important;
}
@media screen and (max-width: 600px) {
    #container {
        height: 200px;
    }
    #container .highcharts-container {
        height: 200px !important;
    }
}
@media screen and (max-width: 380px) {
    #container {
        width: 295px;
        height: 180px;
    }
    #container .highcharts-container {
        height: 180px !important;
    }
}
@media screen and (max-width: 360px) {
    #container {
        width: 280px;
    }
}
</style>

<style lang="scss" scoped>

.highcharts-figure,
.highcharts-data-table table {
  min-width: 310px;
  /*   max-width: 800px;*/
  /* margin: 1em auto; */
  width: 100%;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 500px;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

/* 年齢 */
.age-box {
  position: relative;
  height: 30px;
  clear:both;

    .age {
        position: absolute;
        background-color: #EBEBEB;
        width: 42px;
        height: 30px;
        text-align: center;
        font-size: 20px;

        .sai {
            font-size: 13px;
            margin-left: 1px;
        }
    }


    .age-start {
        left: -20px;
    }

    .age-end {
        right: -20px;
    }

}

.legend-top {
    position: absolute;
    top: 2px;
    right: 40px;

    img {
        width: auto;
        height: 17px;
    }

}

</style>
